import React from 'react'
import dateformat from 'dateformat'

import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ListItem from '@material-ui/core/ListItem';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Table from '@material-ui/core/Table';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';

import Word from '../../../containers/Common/Word'

import { rankItems, countryItems } from '../../../constants';
import { WID } from '../../../constants/Language';

const styles = theme => ({
  gridRoot: {
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit}px`,
    width: '100%',
    margin: 0,
  },
  subTitle: {
    margin: `${theme.spacing.unit * 2}px 0`,
  },
  table: {
    fontSize: '0.875rem',
    maxWidth: 400,
    marginBottom: theme.spacing.unit * 4,
  },
  tableItemCell: {
    width: '50%',
  },
  profileHTMLBox: {
    fontSize: '0.875rem',
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 3}px`,
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: 10,
    marginBottom: theme.spacing.unit * 4,
  }
})

class ProfilePage extends React.Component {
  render() {
    const { classes, userProfile } = this.props
    var item, rank, country, createDateTime

    if (userProfile.rank) {
      item = rankItems.find((item) => item.value === userProfile.rank)
      rank = item ? item.label : undefined
    }
    if (userProfile.country) {
      item = countryItems.find((item) => item.value === userProfile.country)
      country = item ? item.label : undefined
    }
    if (userProfile.createDateTime) {
      createDateTime = dateformat(new Date(userProfile.createDateTime), 'yyyy/m/d')
    }

    return (
      <Grid container spacing={24} className={classes.gridRoot}>
        <Grid item sm={8} xs={12}>
          {userProfile.profileHTML && (
            <React.Fragment>
              <Typography className={classes.subTitle}><Word wid={WID.PROFILE_PAGE.SELF_INTRODUCTION}/></Typography>
              <div className={classes.profileHTMLBox}>
                <span dangerouslySetInnerHTML={{__html: userProfile.profileHTML}}></span>
              </div>
            </React.Fragment>
          )}
          {(rank || country || userProfile.city || userProfile.birthday) && (
            <Table className={classes.table}>
              <TableBody>
                {rank && (
                  <TableRow>
                    <TableCell className={classes.tableItemCell}>
                      <Typography><Word wid={WID.PROFILE_PAGE.RANK_LABEL}/></Typography>
                    </TableCell>
                    <TableCell><Typography>{rank}</Typography></TableCell>
                  </TableRow>
                )}
                {country && (
                  <TableRow>
                    <TableCell>
                      <Typography><Word wid={WID.PROFILE_PAGE.COUNTRY_LABEL}/></Typography>
                    </TableCell>
                    <TableCell><Typography>{country}</Typography></TableCell>
                  </TableRow>
                )}
                {userProfile.city && (
                  <TableRow>
                    <TableCell>
                      <Typography><Word wid={WID.PROFILE_PAGE.CITY_LABEL}/></Typography>
                    </TableCell>
                    <TableCell><Typography>{userProfile.city}</Typography></TableCell>
                  </TableRow>
                )}
                {userProfile.birthday && (
                  <TableRow>
                    <TableCell>
                      <Typography><Word wid={WID.PROFILE_PAGE.BIRTHDAY_LABEL}/></Typography>
                    </TableCell>
                    <TableCell><Typography>{userProfile.birthday}</Typography></TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          )}
        </Grid>
        <Grid item sm={4} xs={12}>
          <List>
            <ListItem>
            {createDateTime && (
              <Typography><Word wid={WID.PROFILE_PAGE.JOINED} insert={{ date: createDateTime }}/></Typography>
            )}
            </ListItem>
            <Divider/>
          </List>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles, { withTheme: true })(ProfilePage)


// WEBPACK FOOTER //
// ./src/Pages/User/components/ProfilePage.js